import { useTranslation } from 'react-i18next';
import { TooltipRenderProps } from 'react-joyride';

import { Button } from './button';

type StepWithImage = TooltipRenderProps['step'] & {
  image?: string;
};

export const TourTooltip = (props: TooltipRenderProps) => {
  const {
    index: stepIndex,
    size: stepsCount,
    step: stepWithImage,
    primaryProps,
    tooltipProps,
    backProps,
  } = props;

  const { t } = useTranslation();

  const step = stepWithImage as StepWithImage;

  return (
    <div
      {...tooltipProps}
      className="max-w-[360px] overflow-hidden rounded-2xl bg-background shadow-lg outline-none sm:data-[state=closed]:zoom-out-95 sm:data-[state=open]:zoom-in-95"
    >
      <div className="flex flex-col gap-6 p-6">
        <div className="flex flex-col gap-3">
          {step.title && (
            <div className="text-2xl font-medium capitalize">{step.title}</div>
          )}

          {step.content && (
            <div className="text-xl text-muted-foreground">{step.content}</div>
          )}
        </div>

        <div className="flex items-center justify-between">
          <div className="text-medium text-xl">
            {stepIndex + 1}/{stepsCount}
          </div>

          <div className="flex items-center gap-3">
            {stepIndex > 0 && (
              <Button size="lg" variant="outline2" onClick={backProps.onClick}>
                {t('shared.previous')}
              </Button>
            )}

            <Button size="lg" variant="contrast" onClick={primaryProps.onClick}>
              {t('shared.next')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

interface MobileTourTooltipProps {
  step: StepWithImage;
  stepIndex: number;
  stepsCount: number;
  onBack: () => void;
  onNext: () => void;
}

export const MobileTourTooltip = (props: MobileTourTooltipProps) => {
  const { step, stepIndex, stepsCount, onBack, onNext } = props;

  const { t } = useTranslation();

  return (
    <div>
      {step.image && (
        <img
          src={step.image}
          alt={`Step ${stepIndex + 1}`}
          className="h-auto w-full"
        />
      )}

      <div className="flex flex-col gap-8 p-5">
        <div className="flex flex-col gap-3">
          <div className="text-medium text-lg">
            {stepIndex + 1}/{stepsCount}
          </div>

          {step.title && (
            <div className="text-xl font-medium capitalize">{step.title}</div>
          )}

          {step.content && (
            <div className="text-lg text-muted-foreground">{step.content}</div>
          )}
        </div>

        <div className="flex items-center gap-3">
          {stepIndex > 0 && (
            <Button
              size="lg"
              variant="outline2"
              className="w-full"
              onClick={onBack}
            >
              {t('shared.previous')}
            </Button>
          )}

          <Button
            size="lg"
            variant="contrast"
            className="w-full"
            onClick={onNext}
          >
            {t('shared.next')}
          </Button>
        </div>
      </div>
    </div>
  );
};
